import { FaInfoCircle } from 'react-icons/fa'
import { Card, Tooltip } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'
import { BatchTooltipText } from '../tootlTipText'
import { BatchTabType, BatchType } from 'features/autocheck/types'

interface IBatchFileProps {
  params: any
  root?: any
  batchResult: any
  batchErrorsData: any
}

export const BatchCount = ({ params, batchResult, root, batchErrorsData }: IBatchFileProps) => {
  return (
    <Div>
      <Card className="batch_files">
        <div className="batch_file_details">
          <table>
            <tbody>
              <tr>
                <td className="header">Total claims in file</td>
                <td>{params.data.totalRecords}</td>
              </tr>
              <tr>
                <td className="header">
                  Excluded from upload
                  <Tooltip
                    tooltipText={BatchTooltipText.excludedFromUpload}
                    position={PositionEnum.bottom}
                    tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(74%) translateX(-12%)' }}
                    positionContent={80}
                    positionTooltipArrow={10}
                  >
                    <FaInfoCircle />
                  </Tooltip>
                </td>
                <td>{batchErrorsData.totalInvalidForImport}</td>
              </tr>

              <tr>
                <td className="header">
                  Imported only{' '}
                  <Tooltip
                    tooltipText={BatchTooltipText.importedOnly}
                    position={PositionEnum.bottom}
                    tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(69%) translateX(-12%)' }}
                    positionContent={80}
                    positionTooltipArrow={10}
                  >
                    <FaInfoCircle />
                  </Tooltip>
                </td>
                <td>
                  {params.data.batchType === BatchType.Claim_Import
                    ? params.data.importOnlyCount
                    : params.data.importOnlyCount - params.data.autocheckCount}
                </td>
              </tr>

              {params.data.batchType != BatchType.Claim_Import &&
                (root === BatchTabType.Processed || root === BatchTabType.EOB) && (
                  <tr>
                    <td className="header">
                      No status{' '}
                      <Tooltip
                        tooltipText={BatchTooltipText.noStatus}
                        position={PositionEnum.bottom}
                        tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(69%) translateX(-12%)' }}
                        positionContent={80}
                        positionTooltipArrow={10}
                      >
                        <FaInfoCircle />
                      </Tooltip>
                    </td>
                    <td>{params.data.noStatus}</td>
                  </tr>
                )}
              {params.data.batchType != BatchType.Claim_Import &&
                (root === BatchTabType.Processed || root === BatchTabType.EOB) && (
                  <>
                    <tr>
                      <td className="header">
                        Stopped for repeat calls{' '}
                        <Tooltip
                          tooltipText={BatchTooltipText.stoppedRepeatCallsOff}
                          position={PositionEnum.bottom}
                          tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(69%) translateX(-12%)' }}
                          positionContent={80}
                          positionTooltipArrow={10}
                        >
                          <FaInfoCircle />
                        </Tooltip>
                      </td>
                      <td>{batchResult.stoppedRepeatCallCount}</td>
                    </tr>
                    <tr>
                      <td className="header">
                        Next action calls{' '}
                        <Tooltip
                          tooltipText={BatchTooltipText.nextActionCalls}
                          position={PositionEnum.bottom}
                          tooltipStyles={{ 'min-width': '15rem', transform: 'translateY(69%) translateX(-12%)' }}
                          positionContent={80}
                          positionTooltipArrow={10}
                        >
                          <FaInfoCircle />
                        </Tooltip>
                      </td>
                      <td>{batchResult.nextActionTakenCount ?? 0}</td>
                    </tr>
                  </>
                )}
            </tbody>
          </table>
        </div>
      </Card>
    </Div>
  )
}

const Div = styled.div`
  .batch_files {
    padding: ${({ theme }) => theme.spacing.s};
    main {
      padding: 0px !important;
    }
    h6 {
      ${({ theme }) => theme.typography.h6.medium};
      color: ${({ theme }) => theme.colors.primary.neutral}!important;
    }
    .batch_file_details {
      display: grid;
      gap: ${({ theme }) => theme.spacing.xxxs};
      table {
        width: 100%;
        tr {
          padding: 0 ${({ theme }) => theme.spacing.xxs}!important;
          height: 32px;
          .header {
            ${({ theme }) => theme.typography.s.medium};
            color: ${({ theme }) => theme.colors.grey.dark};
            width: auto;
            gap: ${({ theme }) => theme.spacing.xxxs};
            text-align: left;
            display: inline-flex;
            svg {
              color: ${({ theme }) => theme.colors.grey.neutral};
            }
          }
          td {
            ${({ theme }) => theme.typography.s.normal};
            color: ${({ theme }) => theme.colors.grey.dark};
            width: 70%;
            text-align: left;
            margin-top: ${({ theme }) => theme.spacing.xxxs};
            .header {
              ${({ theme }) => theme.typography.s.medium};
              color: ${({ theme }) => theme.colors.grey.dark};
              padding-bottom: ${({ theme }) => theme.spacing.xxs};
              width: 30%;
            }
          }
        }
      }
    }
  }
`
